<template></template>

<script>
import { mapActions, mapMutations } from "vuex";
export default {
  methods: {
    ...mapActions("general", ["popLastCrumbItem"]),
    ...mapMutations("general", ["setLoadingOn", "setLoadingOff"]),
  },
  mounted() {
    this.$nextTick(() => {
      this.setLoadingOff();
      this.popLastCrumbItem();
      this.$router.replace("/" + this.$route.params.pathMatch).catch(() => {});
    });
  },
  created() {
    this.setLoadingOn();
  },
};
</script>
